import confirmations from '@flows/configs/common/steps/confirmations'
import email_and_name from '@flows/configs/common/steps/email_and_name'
import failure from '@flows/configs/common/steps/failure'
import gender_step from '@flows/configs/common/steps/gender_step'
import legal_documents_email from '@flows/configs/common/steps/legal_documents_email'
import location from '@flows/configs/common/steps/location'
import payment from '@flows/configs/common/steps/payment'
import success from '@flows/configs/common/steps/success'
import type { CommonConfigProps } from '@flows/configs/common/types'
import type { AnySteps } from '@flows/core/types/stepTypes'

import { getLocationStepContent } from './locationUtils'

export const getCommonFlowConfig = (params: CommonConfigProps) => {
  return {
    emailAndName: email_and_name({
      market: params.getMarket(),
      apiService: params.apiService,
    }),
    gender: gender_step({
      market: params.getMarket(),
    }),
    location: location({ market: params.getMarket() }),
  } as const satisfies AnySteps
}

export const getCommonCheckoutSteps = () => {
  return {
    payment: payment(),
    legal_documents_email: legal_documents_email(),
    confirmations: confirmations(),
    success: success(),
    failure: failure(),
  } as const satisfies AnySteps
}

export { getLocationStepContent }
